import { render, staticRenderFns } from "./quotationIntegration.vue?vue&type=template&id=1984db01&scoped=true"
import script from "./quotationIntegration.vue?vue&type=script&lang=js"
export * from "./quotationIntegration.vue?vue&type=script&lang=js"
import style0 from "./quotationIntegration.vue?vue&type=style&index=0&id=1984db01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1984db01",
  null
  
)

export default component.exports